exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title[data-v-2be1284a]{text-align:center;color:#192A44;margin-bottom:10px\n}\n.info-item[data-v-2be1284a]{font-size:16px;line-height:24px;color:#4a4a4a\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2be1284a","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/configurator/components/OptionInfoModal.vue
// module id = oFwq
// module chunks = 15